import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=8990bb1c&scoped=true"
import script from "./TicketComments.vue?vue&type=script&lang=js"
export * from "./TicketComments.vue?vue&type=script&lang=js"
import style0 from "./TicketComments.vue?vue&type=style&index=0&id=8990bb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8990bb1c",
  null
  
)

export default component.exports